import React from 'react'
import Lottie from 'lottie-react';
import "./File_animation.css";
import animationData from './File_animation.json';

function File_animation() {
  return (
    <section className='File_animation'>
      <Lottie
        animationData={animationData}
        loop={true}
        autoplay={true}
        className="File_lottie"
      />
    </section>
  )
}

export default File_animation